module.exports = __webpack_public_path__ + "img/PII.e4ccb301.jpg";